import { GET_RATE_LIST_REQUEST, GET_RATE_LIST_SUCCESS, GET_RATE_LIST_FAILURE, GET_RATE_LIST_RESET, } from "../../actions";
const initialState = {
    CarrierRateData: null,
    loading: false,
    error: null,
};
const getCarrierRateReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RATE_LIST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, CarrierRateData: action.payload });
        case GET_RATE_LIST_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, CarrierRateData: null, error: null });
        case GET_RATE_LIST_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, CarrierRateData: null });
        case GET_RATE_LIST_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, CarrierRateData: null, error: null });
        default:
            return state;
    }
};
export default getCarrierRateReducer;
